import { type ComponentProps, type FC, useEffect, useRef, useState, useMemo } from "react";
import { InformationCard } from "@userFrontend/components/InformationCard";
import { ReadMoreButton } from "@root/shared/components/ReadMoreButton";
import { JobEntryCheckbox } from "@userFrontend/components/JobEntryCheckbox";
import * as styles from "./styles.css";

type Props = {
  checkedJobEntryIds: number[];
  thinkingEntriesWithoutUserEmployed: Pick<
    ComponentProps<typeof JobEntryCheckbox>,
    "clientName" | "brandName" | "workTitle" | "jobEntryId"
  >[];
  handleChangeSelectedEntryId: (entryId: number, isChecked: boolean) => void;
};

export const EntryClientSelect: FC<Props> = ({
  checkedJobEntryIds,
  thinkingEntriesWithoutUserEmployed,
  handleChangeSelectedEntryId,
}) => {
  const [containerHeight, setContainerHeight] = useState<number | undefined>(undefined);
  const jobEntryRefs = useRef<(HTMLDivElement | null)[]>([]);
  const thinkingEntriesReadMoreButton = useMemo(
    () => thinkingEntriesWithoutUserEmployed.length >= 3,
    [thinkingEntriesWithoutUserEmployed],
  );

  useEffect(() => {
    if (
      jobEntryRefs.current[0] &&
      jobEntryRefs.current[1] &&
      jobEntryRefs.current[2] &&
      setContainerHeight
    ) {
      const totalRefHeight =
        jobEntryRefs.current[0].offsetHeight +
        jobEntryRefs.current[1].offsetHeight +
        jobEntryRefs.current[2].offsetHeight;
      setContainerHeight(totalRefHeight);
    }
  }, [thinkingEntriesWithoutUserEmployed, setContainerHeight]);

  const renderJobEntryButtons = useMemo(() => {
    return thinkingEntriesWithoutUserEmployed.map(
      ({ clientName, brandName, workTitle, jobEntryId }, index) => (
        <div key={jobEntryId} ref={(el) => (jobEntryRefs.current[index] = el)}>
          <JobEntryCheckbox
            brandName={brandName}
            clientName={clientName}
            workTitle={workTitle}
            jobEntryId={jobEntryId}
            disabled={false}
            isSp
            checked={checkedJobEntryIds.includes(jobEntryId)}
            isError={false}
            handleChangeEntryClient={() => {
              handleChangeSelectedEntryId(jobEntryId, !checkedJobEntryIds.includes(jobEntryId));
            }}
            name="user_withdrawal_reason[thinking_job_entry_ids][]"
          />
        </div>
      ),
    );
  }, [thinkingEntriesWithoutUserEmployed, checkedJobEntryIds, handleChangeSelectedEntryId]);

  return (
    <>
      <InformationCard>
        <div className={styles.buttonWrapper}>
          {thinkingEntriesReadMoreButton ? (
            <ReadMoreButton size="large" containerMaxHeight={containerHeight}>
              <>{renderJobEntryButtons}</>
            </ReadMoreButton>
          ) : (
            <>{renderJobEntryButtons}</>
          )}
        </div>
      </InformationCard>
    </>
  );
};
